// SEO landing pages – 43 total (13 originals + 30 expansion).
// Each entry: slug, category, title (H1), lead, ctaLabel, prefill (deep-link),
// metaTitle, metaDescription, and 2-3 FAQ items.
// whatToDo / docs are auto-generated from category by seoContent.js unless overridden.

export const SEO_PAGES = [
  // -------- Category hubs (existing, keep) --------
  {
    slug: "abonelik-iptali",
    category: "telecom-internet",
    title: "Abonelik iptali nasıl yapılır?",
    lead:
      "İnternet, telefon, TV veya dijital üyelik aboneliğinizi doğru kanaldan sonlandırmak, cayma bedeline itiraz etmek ve iptal sonrası fatura sorununu takip etmek için Abonelik İptal yanınızda.",
    ctaLabel: "İptal başvurumu hazırla",
    prefill: { issue: "iptal" },
    metaTitle: "Abonelik İptali | Abonelik İptal",
    metaDescription:
      "İnternet, TV, mobil hat ve dijital platform abonelikleri için iptal başvurusu, cayma bedeli itirazı ve takip planı hazırlayın.",
    faq: [
      { q: "Abonelik iptali için hangi belgeler gerekir?", a: "Son faturanız, iptal başvurusu ekran görüntüsü veya işlem numarası ve varsa modem/dekoder iade tutanağı yeterlidir." },
      { q: "Cayma bedeli çıkarılırsa ne yapmalıyım?", a: "Yazılı itirazınızı kuruma iletin ve kayıt numarasını saklayın; sonuç alınamazsa Tüketici Hakem Heyeti başvurusu için dosyanızı Abonelik İptal ile hazırlayabilirsiniz." },
      { q: "Abonelik İptal resmi bir kurum mudur?", a: "Hayır. Abonelik İptal resmi kurum değildir ve hukuki danışmanlık vermez; başvurunuzu ve takip planınızı kolaylaştıran bir tüketici işlem asistanıdır." },
    ],
  },
  {
    slug: "iade-itiraz",
    category: "ecommerce",
    title: "İade & itiraz süreciniz için doğru yol",
    lead:
      "E-ticaret siparişlerinde iade, değişim, para iadesi ve ayıplı ürün sorunları için başvuru metnini ve gerekli belgeleri Abonelik İptal ile hazırlayın.",
    ctaLabel: "İade başvurumu hazırla",
    prefill: { issue: "iade" },
    metaTitle: "İade, Değişim ve Para İadesi İtirazı | Abonelik İptal",
    metaDescription:
      "E-ticaret siparişlerinde iade, değişim, para iadesi gecikmesi ve ayıplı ürün sorunları için hazır başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "Para iadem yatmadıysa ne yapabilirim?", a: "Platform içinden iade talebini açtığınıza dair belgeleri saklayın; 14 gün içinde iade yapılmazsa yazılı itiraz metnini Abonelik İptal ile hazırlayabilirsiniz." },
      { q: "İadem reddedildiyse ne yapmalıyım?", a: "Ret gerekçesini yazılı isteyin, ürün fotoğrafı ve kargo fişini saklayın; gerekirse Tüketici Hakem Heyeti başvurusu için dosya oluşturun." },
    ],
  },
  {
    slug: "tuketici-hakem-heyeti",
    category: "dilekce",
    title: "Tüketici Hakem Heyeti başvurusu",
    lead:
      "Belgelerinizi toparlayın, başvuru metninizi oluşturun, eksiklerinizi Abonelik İptal'in kontrol listesinden görün.",
    ctaLabel: "Hakem heyeti başvurumu hazırla",
    prefill: { issue: "hakem" },
    metaTitle: "Tüketici Hakem Heyeti Başvuru Metni | Abonelik İptal",
    metaDescription:
      "Tüketici Hakem Heyeti başvuru dilekçesi, belge kontrol listesi ve itiraz metni hazırlayın; sürecinizi Abonelik İptal ile takip edin.",
    faq: [
      { q: "Tüketici Hakem Heyeti'ne kim başvurabilir?", a: "6502 sayılı Tüketicinin Korunması Hakkında Kanun kapsamında, uyuşmazlığa konu tutarın belirlenen sınırın altında kaldığı durumlarda tüketiciler başvurabilir." },
      { q: "Hangi belgeler gerekir?", a: "Fatura veya sipariş belgesi, ödeme dekontu, satıcı/kurumla yapılmış yazışmalar ve varsa kargo fişleri gereklidir." },
    ],
  },

  // -------- Existing 7 kurum-özel (keep) --------
  {
    slug: "vodafone-net-iptal",
    category: "telecom-internet",
    title: "Vodafone Net abonelik iptali",
    lead: "Vodafone Net aboneliğinizi iptal etmek, cayma bedeline itiraz etmek veya iptal sonrası fatura sorununu takip etmek için dosya oluşturun.",
    ctaLabel: "Vodafone Net iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Vodafone Net" },
    metaTitle: "Vodafone Net İptal Süreci ve Hazır Başvuru Metni | Abonelik İptal",
    metaDescription: "Vodafone Net abonelik iptali, iptal sonrası fatura ve cayma bedeli süreçleri için hazır başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "Vodafone Net aboneliğimi nasıl iptal ederim?", a: "Öncelikle Vodafone Net'in resmi iptal kanalını (çevrimiçi hesap, mobil uygulama, çağrı merkezi veya bayi) kullanın ve başvuru numarasını saklayın." },
      { q: "İptal ettim ama fatura kesilmeye devam ediyor, ne yapmalıyım?", a: "İptal başvurunuzun belgelerini ve son faturayı toplayın; yazılı itiraz metnini Abonelik İptal ile hazırlayıp Vodafone Net'e ve gerekirse Tüketici Hakem Heyeti'ne iletebilirsiniz." },
    ],
  },
  {
    slug: "superonline-iptal",
    category: "telecom-internet",
    title: "Turkcell Superonline iptali",
    lead: "Superonline aboneliğinizi sonlandırmak, cayma bedeline itiraz etmek ve iptal sonrası ücret sorunlarını çözmek için dosyanızı hazırlayın.",
    ctaLabel: "Superonline iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Turkcell Superonline" },
    metaTitle: "Superonline İptal Süreci ve Hazır Başvuru Metni | Abonelik İptal",
    metaDescription: "Superonline abonelik iptali, cayma bedeli ve iptal sonrası fatura sorunları için hazır metin ve takip planı oluşturun.",
    faq: [
      { q: "Superonline'da cayma bedeli nasıl itiraz edilir?", a: "Yazılı itirazınızı Superonline'a iletin ve kayıt numarasını saklayın; sonuç alınmazsa hazırladığımız itiraz metnini Tüketici Hakem Heyeti başvurusuna ekleyebilirsiniz." },
    ],
  },
  {
    slug: "turk-telekom-internet-iptal",
    category: "telecom-internet",
    title: "Türk Telekom internet iptali",
    lead: "Türk Telekom internet aboneliğinizin iptali, taahhüt/cayma bedeli ve iade süreçleri için Abonelik İptal ile ilerleyin.",
    ctaLabel: "Türk Telekom iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Türk Telekom" },
    metaTitle: "Türk Telekom İnternet İptal Süreci | Abonelik İptal",
    metaDescription: "Türk Telekom ev interneti iptali, fatura itirazı ve cayma bedeli süreçleri için başvuru metni ve takip planı hazırlayın.",
    faq: [
      { q: "Türk Telekom taahhüt süresi dolmadan iptal olur mu?", a: "Evet, mevzuat çerçevesinde iptal edebilirsiniz; ancak cayma bedeli tahakkuk edebilir. Cayma bedeline yazılı itiraz için Abonelik İptal dosyası oluşturabilirsiniz." },
    ],
  },
  {
    slug: "dsmart-iptal",
    category: "telecom-internet",
    title: "D-Smart abonelik iptali",
    lead: "D-Smart aboneliğinizi iptal etmek, cayma bedeline itiraz etmek ve dekoder iadesi süreçleri için doğru yolu bulun.",
    ctaLabel: "D-Smart iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "D-Smart" },
    metaTitle: "D-Smart İptal Süreci ve Başvuru Metni | Abonelik İptal",
    metaDescription: "D-Smart abonelik iptali, dekoder iadesi, cayma bedeli ve fatura itirazı için hazır başvuru metni oluşturun.",
    faq: [
      { q: "D-Smart dekoderini nasıl iade ederim?", a: "D-Smart'ın belirttiği iade adresine veya anlaşmalı kargoya teslim edin; kargo fişini ve iade tutanağını mutlaka saklayın." },
    ],
  },
  {
    slug: "digiturk-iptal",
    category: "telecom-internet",
    title: "Digiturk / beIN abonelik iptali",
    lead: "Digiturk / beIN aboneliğinizi sonlandırmak, cayma bedeline itiraz etmek ve iptal sonrası fatura sorunları için dosya oluşturun.",
    ctaLabel: "Digiturk iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Digiturk / beIN" },
    metaTitle: "Digiturk İptal Süreci ve Hazır Başvuru Metni | Abonelik İptal",
    metaDescription: "Digiturk/beIN abonelik iptali, cihaz iadesi, fatura ve cayma bedeli itirazları için hazır metin hazırlayın.",
    faq: [
      { q: "Digiturk aboneliği iptali için resmi kanal nedir?", a: "Digiturk'ün çağrı merkezi veya online hesap kanalı üzerinden iptal başvurusu yapabilir, işlem numarasını saklayabilirsiniz." },
    ],
  },
  {
    slug: "trendyol-iade-itiraz",
    category: "ecommerce",
    title: "Trendyol iade & itiraz süreci",
    lead: "Trendyol siparişinizde iade, değişim, para iadesi ve satıcı sorunları için başvuru metninizi Abonelik İptal ile hazırlayın.",
    ctaLabel: "Trendyol iade başvurumu hazırla",
    prefill: { issue: "iade", company: "Trendyol" },
    metaTitle: "Trendyol İade ve Para İadesi İtirazı | Abonelik İptal",
    metaDescription: "Trendyol para iadesi gecikmesi, iade reddi ve satıcı sorunları için hazır başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "Trendyol para iadem ne kadar sürede yapılır?", a: "Mesafeli Sözleşmeler Yönetmeliği kapsamında ödeme yönteminize göre en geç 14 gün içinde iade yapılması beklenir." },
      { q: "İade talebim reddedildiyse ne yapabilirim?", a: "Ret gerekçesini yazılı isteyin, sipariş ve kargo bilgilerinizi saklayın; Abonelik İptal ile itiraz metninizi hazırlayıp Trendyol'a ve Tüketici Hakem Heyeti'ne iletebilirsiniz." },
    ],
  },
  {
    slug: "hepsiburada-iade-itiraz",
    category: "ecommerce",
    title: "Hepsiburada iade & itiraz süreci",
    lead: "Hepsiburada siparişinizde iade, değişim veya para iadesi sorunları için doğru başvuru yolunu ve gerekli belgeleri görün.",
    ctaLabel: "Hepsiburada iade başvurumu hazırla",
    prefill: { issue: "iade", company: "Hepsiburada" },
    metaTitle: "Hepsiburada İade ve Para İadesi İtirazı | Abonelik İptal",
    metaDescription: "Hepsiburada iade, değişim, para iadesi ve satıcı sorunları için hazır başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "Hepsiburada iade sürecim ne kadar sürer?", a: "İade talebi onaylandıktan sonra ödeme yönteminize göre en geç 14 gün içinde iade yapılması beklenir; gecikme halinde yazılı itiraz hazırlanabilir." },
    ],
  },

  // =============== SPRINT 1: 30 NEW PAGES ===============

  // --- 1. İnternet / TV abonelik iptali (7) ---
  {
    slug: "millenicom-iptal",
    category: "telecom-internet",
    title: "Millenicom abonelik iptali",
    lead: "Millenicom internet aboneliğinizi sonlandırmak, taahhüt farkı veya cayma bedeline itiraz etmek için başvuru metninizi hazırlayın.",
    ctaLabel: "Millenicom iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Millenicom" },
    metaTitle: "Millenicom İptal Süreci ve Hazır Başvuru Metni | Abonelik İptal",
    metaDescription: "Millenicom internet aboneliği iptali, iptal sonrası fatura ve cayma bedeli süreçleri için hazır başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "Millenicom iptali için önce ne yapmalıyım?", a: "Çağrı merkezi veya çevrimiçi kanaldan iptal başvurusu yapın ve işlem numarasını mutlaka saklayın." },
      { q: "Modem iadesi nasıl olur?", a: "Millenicom'un bildirdiği adrese veya anlaşmalı kargoya teslim edin; kargo fişini ve iade tutanağını saklayın." },
    ],
  },
  {
    slug: "turknet-iptal",
    category: "telecom-internet",
    title: "TurkNet abonelik iptali",
    lead: "TurkNet aboneliğinizi sonlandırmak, cayma bedeline itiraz etmek ve iptal sonrası fatura sorunlarını takip etmek için dosya oluşturun.",
    ctaLabel: "TurkNet iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "TurkNet" },
    metaTitle: "TurkNet İptal Süreci ve Hazır Başvuru Metni | Abonelik İptal",
    metaDescription: "TurkNet ev interneti iptali, cayma bedeli itirazı ve iptal sonrası fatura süreçleri için hazır metin ve takip planı oluşturun.",
    faq: [
      { q: "TurkNet aboneliğim taahhütlüyse iptal olur mu?", a: "Evet, iptal edebilirsiniz; taahhüt döneminde cayma bedeli tahakkuk edebilir. Bu bedele yazılı itiraz için Abonelik İptal dosyası oluşturabilirsiniz." },
    ],
  },
  {
    slug: "kablonet-iptal",
    category: "telecom-internet",
    title: "KabloNet abonelik iptali",
    lead: "KabloNet internet aboneliğinizi iptal etmek, cihaz iadesi ve cayma bedeli süreçleri için başvuru metninizi ve belge listenizi hazırlayın.",
    ctaLabel: "KabloNet iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "KabloNet" },
    metaTitle: "KabloNet İptal Süreci ve Başvuru Metni | Abonelik İptal",
    metaDescription: "KabloNet aboneliği iptali, cihaz iadesi, cayma bedeli ve iptal sonrası fatura sorunları için hazır metin oluşturun.",
    faq: [
      { q: "KabloNet cihaz iadesi zorunlu mudur?", a: "Kurumdan kiralanan modem/router kurallara göre iade edilmelidir. İade tutanağını mutlaka saklayın." },
    ],
  },
  {
    slug: "kablo-tv-iptal",
    category: "telecom-internet",
    title: "Kablo TV abonelik iptali",
    lead: "Kablo TV aboneliğinizi sonlandırmak ve iptal sonrası fatura veya cihaz iadesi sorunları için doğru yolu bulun.",
    ctaLabel: "Kablo TV iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Kablo TV" },
    metaTitle: "Kablo TV Abonelik İptali | Abonelik İptal",
    metaDescription: "Kablo TV aboneliği iptali, dekoder iadesi ve iptal sonrası fatura süreçleri için hazır başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "İptal ettim ama Kablo TV faturası gelmeye devam ediyor, ne yapayım?", a: "İptal başvuru belgesini toplayın; Abonelik İptal ile yazılı itiraz metnini hazırlayıp Kablo TV'ye iletebilirsiniz." },
    ],
  },
  {
    slug: "tivibu-iptal",
    category: "telecom-internet",
    title: "Tivibu abonelik iptali",
    lead: "Tivibu aboneliğinizi iptal etmek, iptal sonrası ücretler ve cayma bedeli sorunları için dosya oluşturun.",
    ctaLabel: "Tivibu iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Tivibu" },
    metaTitle: "Tivibu İptal Süreci ve Başvuru Metni | Abonelik İptal",
    metaDescription: "Tivibu aboneliği iptali, cihaz iadesi ve fatura itirazı süreçleri için hazır başvuru metni oluşturun.",
    faq: [
      { q: "Tivibu iptali telefondan yapılabilir mi?", a: "Çağrı merkezi veya çevrimiçi hesap üzerinden başvuru yapılabilir; işlem numarası ve kaydı mutlaka saklayın." },
    ],
  },
  {
    slug: "vodafone-ev-interneti-iptal",
    category: "telecom-internet",
    title: "Vodafone Ev İnterneti iptali",
    lead: "Vodafone Ev İnterneti aboneliğinizi sonlandırmak, cayma bedeline itiraz etmek ve modem iadesi süreçleri için başvuru metninizi hazırlayın.",
    ctaLabel: "Vodafone Ev İnterneti iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Vodafone Ev İnterneti" },
    metaTitle: "Vodafone Ev İnterneti İptal Süreci | Abonelik İptal",
    metaDescription: "Vodafone Ev İnterneti iptali, modem iadesi ve cayma bedeli süreçleri için hazır başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "Vodafone Ev İnterneti modem iadesi nasıl olur?", a: "Vodafone'un bildirdiği kargo firmasıyla modemi iade edin; kargo fişini ve iade tutanağını saklayın." },
    ],
  },
  {
    slug: "turkcell-superbox-iptal",
    category: "telecom-internet",
    title: "Turkcell Superbox iptali",
    lead: "Turkcell Superbox aboneliğinizi iptal etmek, cihaz iadesi ve cayma bedeli itirazı için Abonelik İptal ile dosyanızı hazırlayın.",
    ctaLabel: "Superbox iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Turkcell Superbox" },
    metaTitle: "Turkcell Superbox İptal Süreci | Abonelik İptal",
    metaDescription: "Turkcell Superbox aboneliği iptali, cihaz iadesi ve cayma bedeli itirazı için hazır başvuru metni oluşturun.",
    faq: [
      { q: "Superbox cihazını iade etmezsem ne olur?", a: "Cihaz bedeli tahakkuk edebilir. Cihazın kargoyla iadesi ve tutanağın saklanması olası fatura itirazında lehinizedir." },
    ],
  },

  // --- 2. Dijital abonelik iptali (9) ---
  {
    slug: "netflix-uyelik-iptali",
    category: "digital",
    title: "Netflix üyelik iptali",
    lead: "Netflix üyeliğinizi hesap ayarlarından iptal edin, iptal sonrası ödeme kesintilerini kontrol edin ve gerekirse itiraz metnini Abonelik İptal ile hazırlayın.",
    ctaLabel: "Netflix iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Netflix" },
    metaTitle: "Netflix Üyelik İptali Nasıl Yapılır? | Abonelik İptal",
    metaDescription: "Netflix üyeliğinizi iptal etmek, ödeme kesintilerini kontrol etmek ve iptal sonrası takip planı oluşturmak için Abonelik İptal ile hazır iptal metni hazırlayın.",
    faq: [
      { q: "Netflix'i iptal ettim ama kart yeniden çekildi, ne yapmalıyım?", a: "İptal onayı e-postası, kart ekstresi ve tarih bilgilerini bir araya getirin; Abonelik İptal ile iade/itiraz metnini hazırlayıp Netflix'e iletebilirsiniz." },
      { q: "Netflix'te dönem ortasında iptal iade olur mu?", a: "Genellikle mevcut dönem sonuna kadar hizmet devam eder; iade politikası her ülke ve plana göre değişir." },
    ],
  },
  {
    slug: "spotify-premium-iptal",
    category: "digital",
    title: "Spotify Premium iptali",
    lead: "Spotify Premium üyeliğinizi hesap ayarlarınızdan iptal edin ve iptal sonrası ücret sorunlarını Abonelik İptal ile takip edin.",
    ctaLabel: "Spotify iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Spotify Premium" },
    metaTitle: "Spotify Premium İptal Süreci | Abonelik İptal",
    metaDescription: "Spotify Premium üyelik iptali, iptal sonrası ücret sorunları ve iade talepleri için hazır başvuru metni oluşturun.",
    faq: [
      { q: "Spotify Premium iptali sonrası ne olur?", a: "Mevcut ödeme döneminizin sonuna kadar Premium erişimini kullanır, sonrasında ücretsiz plana geçersiniz." },
    ],
  },
  {
    slug: "exxen-abonelik-iptali",
    category: "digital",
    title: "Exxen abonelik iptali",
    lead: "Exxen aboneliğinizi iptal etmek, otomatik yenileme sonrası çekilen ücretler için itiraz metni hazırlamak isterseniz Abonelik İptal yanınızda.",
    ctaLabel: "Exxen iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Exxen" },
    metaTitle: "Exxen Abonelik İptali | Abonelik İptal",
    metaDescription: "Exxen aboneliğinizi iptal edin, otomatik yenileme sonrası ücret sorunlarını Abonelik İptal ile takip edin.",
    faq: [
      { q: "Exxen otomatik yenilemeyi nasıl kapatırım?", a: "Hesap ayarlarınızdan abonelik yönetim ekranına giderek otomatik yenilemeyi devre dışı bırakabilirsiniz." },
    ],
  },
  {
    slug: "blutv-uyelik-iptali",
    category: "digital",
    title: "BluTV üyelik iptali",
    lead: "BluTV üyeliğinizi hesap ayarlarınızdan iptal edin ve iptal sonrası ücret sorunları için itiraz metnini Abonelik İptal ile hazırlayın.",
    ctaLabel: "BluTV iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "BluTV" },
    metaTitle: "BluTV Üyelik İptali | Abonelik İptal",
    metaDescription: "BluTV üyelik iptali, otomatik yenileme ve iade süreçleri için hazır başvuru metni oluşturun.",
    faq: [
      { q: "BluTV iptali onaylandıktan sonra ne yapmalıyım?", a: "İptal onayı e-postasını saklayın ve bir sonraki dönem kart ekstresini kontrol edin." },
    ],
  },
  {
    slug: "tod-uyelik-iptali",
    category: "digital",
    title: "TOD üyelik iptali",
    lead: "TOD üyeliğinizi iptal etmek ve otomatik yenileme sonrası ücretler için itiraz metni hazırlamak isterseniz Abonelik İptal ile ilerleyin.",
    ctaLabel: "TOD iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "TOD" },
    metaTitle: "TOD Üyelik İptali ve İade Talebi | Abonelik İptal",
    metaDescription: "TOD üyelik iptali, otomatik yenileme sonrası ücret sorunları ve iade süreçleri için hazır başvuru metni hazırlayın.",
    faq: [
      { q: "TOD'da iptal sonrası içeriğe erişim ne zaman kesilir?", a: "İptal ettiğiniz dönem sonuna kadar erişiminiz sürer, sonrasında hesabınız ücretli içeriğe erişemez." },
    ],
  },
  {
    slug: "youtube-premium-iptal",
    category: "digital",
    title: "YouTube Premium iptali",
    lead: "YouTube Premium üyeliğinizi Google hesap ayarlarından iptal edin, kart kesintilerini kontrol edin ve gerektiğinde iade talebinizi Abonelik İptal ile oluşturun.",
    ctaLabel: "YouTube Premium iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "YouTube Premium" },
    metaTitle: "YouTube Premium Üyelik İptali | Abonelik İptal",
    metaDescription: "YouTube Premium üyelik iptali, Google Play üzerinden yenileme sorunları ve iade talepleri için hazır başvuru metni oluşturun.",
    faq: [
      { q: "YouTube Premium'u iptal ettim ama ücret çekildi, ne yapmalıyım?", a: "Google Play ödeme geçmişini kontrol edin; iade talebi için Abonelik İptal ile hazır metin oluşturabilirsiniz." },
    ],
  },
  {
    slug: "amazon-prime-iptal",
    category: "digital",
    title: "Amazon Prime iptali",
    lead: "Amazon Prime üyeliğinizi hesap ayarlarınızdan iptal edin ve iptal sonrası fatura veya iade sorunları için Abonelik İptal ile başvuru metnini hazırlayın.",
    ctaLabel: "Amazon Prime iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Amazon Prime" },
    metaTitle: "Amazon Prime Üyelik İptali | Abonelik İptal",
    metaDescription: "Amazon Prime üyelik iptali, iptal sonrası fatura ve iade süreçleri için hazır başvuru metni oluşturun.",
    faq: [
      { q: "Amazon Prime iptali kısmi iade sağlar mı?", a: "Amazon'un politikasına ve kullanım durumuna göre kısmi iade mümkün olabilir; talebinizi Abonelik İptal ile yazılı olarak iletebilirsiniz." },
    ],
  },
  {
    slug: "google-play-abonelik-iptali",
    category: "digital",
    title: "Google Play abonelik iptali",
    lead: "Google Play üzerinden aldığınız uygulama aboneliklerini iptal edin ve iade taleplerinizi Abonelik İptal ile başvuru metnine dönüştürün.",
    ctaLabel: "Google Play iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Google Play" },
    metaTitle: "Google Play Abonelik İptali ve İade Talebi | Abonelik İptal",
    metaDescription: "Google Play üzerinden alınan uygulama abonelikleri için iptal, iade talebi ve otomatik yenileme sorunları için hazır başvuru metni hazırlayın.",
    faq: [
      { q: "Google Play'de iade talebi nasıl açılır?", a: "Google Play'de satın alma geçmişinizden ilgili işleme gidip iade talebi açabilirsiniz; reddedilirse Abonelik İptal ile itiraz metni hazırlanabilir." },
    ],
  },
  {
    slug: "apple-app-store-abonelik-iptali",
    category: "digital",
    title: "App Store abonelik iptali",
    lead: "Apple App Store üzerinden aldığınız uygulama aboneliklerini iptal edin ve iade taleplerinizi Abonelik İptal ile hazırlayın.",
    ctaLabel: "App Store iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Apple App Store" },
    metaTitle: "Apple App Store Abonelik İptali ve İade | Abonelik İptal",
    metaDescription: "Apple App Store üzerinden alınan uygulama abonelikleri için iptal, iade ve otomatik yenileme sorunları için hazır başvuru metni hazırlayın.",
    faq: [
      { q: "App Store aboneliği iade talebi nereye yapılır?", a: "reportaproblem.apple.com üzerinden iade talebi açabilirsiniz; reddedilirse Abonelik İptal ile yazılı itiraz metnini hazırlayabilirsiniz." },
    ],
  },

  // --- 3. Mobil hat iptali (3) ---
  {
    slug: "turkcell-hat-iptali",
    category: "mobile",
    title: "Turkcell hat iptali",
    lead: "Turkcell mobil hattınızı iptal etmek veya numara taşımak için doğru yolu bulun; fesih dilekçenizi ve fatura itirazlarınızı Abonelik İptal ile hazırlayın.",
    ctaLabel: "Turkcell iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Turkcell" },
    metaTitle: "Turkcell Hat İptali ve Fesih Dilekçesi | Abonelik İptal",
    metaDescription: "Turkcell mobil hat iptali, cayma bedeli itirazı ve iptal sonrası fatura süreçleri için hazır başvuru metni hazırlayın.",
    faq: [
      { q: "Turkcell hat iptali için nereye gitmeliyim?", a: "Kimliğinizle Turkcell bayisine gidip fesih formunu doldurabilir veya çevrimiçi kanallardan başvurabilirsiniz." },
    ],
  },
  {
    slug: "vodafone-hat-iptali",
    category: "mobile",
    title: "Vodafone hat iptali",
    lead: "Vodafone mobil hattınızı iptal etmek ve iptal sonrası fatura ile cayma bedeli itirazlarınızı Abonelik İptal ile hazırlayın.",
    ctaLabel: "Vodafone hat iptali başvurumu hazırla",
    prefill: { issue: "iptal", company: "Vodafone" },
    metaTitle: "Vodafone Hat İptali ve Fesih Dilekçesi | Abonelik İptal",
    metaDescription: "Vodafone mobil hat iptali, cayma bedeli itirazı ve iptal sonrası fatura süreçleri için başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "Vodafone'da fesih dilekçesi yazılı mı olmalı?", a: "Evet, bayide yazılı fesih başvurusu yapılır; formun bir nüshasını mutlaka saklayın." },
    ],
  },
  {
    slug: "turk-telekom-mobil-hat-iptali",
    category: "mobile",
    title: "Türk Telekom mobil hat iptali",
    lead: "Türk Telekom mobil hattınızı iptal etmek, iptal sonrası fatura ve cayma bedeli itirazlarınızı Abonelik İptal ile hazırlayın.",
    ctaLabel: "Türk Telekom mobil iptal başvurumu hazırla",
    prefill: { issue: "iptal", company: "Türk Telekom Mobil" },
    metaTitle: "Türk Telekom Mobil Hat İptali | Abonelik İptal",
    metaDescription: "Türk Telekom mobil hat iptali, cayma bedeli itirazı ve fatura süreçleri için hazır başvuru metni hazırlayın.",
    faq: [
      { q: "Türk Telekom'da iptal sonrası son fatura ne zaman gelir?", a: "İptal işleminden sonra ilgili dönem faturası tahakkuk edebilir; itiraza konu bir kalem varsa yazılı olarak itiraz edin." },
    ],
  },

  // --- 4. İtiraz / dilekçe (5) ---
  {
    slug: "cayma-bedeli-itiraz-dilekcesi",
    category: "dilekce",
    title: "Cayma bedeli itiraz dilekçesi",
    lead: "Haksız olduğunu düşündüğünüz cayma bedeli için Abonelik İptal ile hazır itiraz metnini oluşturun, gerekli belgeleri ve takip planınızı görün.",
    ctaLabel: "Cayma bedeli itiraz başvurumu hazırla",
    prefill: { issue: "fatura" },
    metaTitle: "Cayma Bedeli İtiraz Dilekçesi Hazırlama | Abonelik İptal",
    metaDescription: "Haksız olduğunu düşündüğünüz cayma bedeli için itiraz metni, gerekli belgeler ve takip planını Abonelik İptal ile hazırlayın.",
    faq: [
      { q: "Cayma bedeli hangi durumlarda haksız sayılabilir?", a: "Taahhüt süresi dolduysa, hizmet alınmadıysa veya cayma bedelinin tutarı sözleşmeye aykırıysa itiraz gerekçesi güçlenir." },
      { q: "İtirazım reddedilirse ne yapabilirim?", a: "Yanıtın yazılı olmasını isteyin; Tüketici Hakem Heyeti başvurusu için dosyanızı Abonelik İptal ile hazırlayabilirsiniz." },
    ],
  },
  {
    slug: "iptal-sonrasi-fatura-itirazi",
    category: "dilekce",
    title: "İptal sonrası fatura itirazı",
    lead: "Aboneliğinizi iptal ettikten sonra kesilmeye devam eden faturalar için Abonelik İptal ile hazır itiraz metnini oluşturun.",
    ctaLabel: "İptal sonrası fatura itiraz başvurumu hazırla",
    prefill: { issue: "fatura" },
    metaTitle: "İptal Sonrası Fatura İtirazı Nasıl Yapılır? | Abonelik İptal",
    metaDescription: "Abonelik iptali sonrasında kesilen faturalar için itiraz dilekçesi, gerekli belgeler ve takip planınızı Abonelik İptal ile hazırlayın.",
    faq: [
      { q: "İptal başvurumun belgeleri yoksa itirazım geçersiz mi?", a: "Belge zayıflığı süreci uzatır; ilk adım, çağrı kaydı numarası veya ekran görüntüsü olarak ne varsa toplamaktır." },
    ],
  },
  {
    slug: "fatura-itiraz-dilekcesi",
    category: "dilekce",
    title: "Fatura itiraz dilekçesi",
    lead: "Haksız fatura kalemi, kullanılmayan hizmet ücreti veya sözleşme dışı ek ücretler için Abonelik İptal ile yazılı itiraz metninizi hazırlayın.",
    ctaLabel: "Fatura itiraz başvurumu hazırla",
    prefill: { issue: "fatura" },
    metaTitle: "Fatura İtiraz Dilekçesi Hazırlama | Abonelik İptal",
    metaDescription: "Haksız fatura kalemleri, sözleşme dışı ücretler ve kullanılmayan hizmet bedelleri için itiraz dilekçesi ve takip planı hazırlayın.",
    faq: [
      { q: "Fatura son ödeme tarihi geçtiyse itiraz edebilir miyim?", a: "İtiraz edilebilir; ancak yazılı başvurunuzu son ödeme tarihinden önce yapmanız pozisyonunuzu güçlendirir." },
    ],
  },
  {
    slug: "modem-iadesi-sorunu",
    category: "dilekce",
    title: "Modem iadesi sorunu",
    lead: "Kurumdan kiralanan modemin iadesi sırasında yaşanan tutanak, cihaz bedeli veya kargo sorunları için hazır itiraz metni hazırlayın.",
    ctaLabel: "Modem iadesi başvurumu hazırla",
    prefill: { issue: "fatura" },
    metaTitle: "Modem İadesi Sorunu ve İtiraz Dilekçesi | Abonelik İptal",
    metaDescription: "Modem iadesi sırasında yaşanan cihaz bedeli, tutanak veya kargo sorunları için hazır başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "Modemi kargoya verdim ama cihaz bedeli tahakkuk etti, ne yapmalıyım?", a: "Kargo takip numarası, kargo fişi ve iade tutanağını toplayın; Abonelik İptal ile itiraz metninizi hazırlayabilirsiniz." },
    ],
  },
  {
    slug: "dekoder-iadesi-sorunu",
    category: "dilekce",
    title: "Dekoder iadesi sorunu",
    lead: "TV aboneliği sonlandırıldıktan sonra dekoder iadesi ile ilgili tutanak veya cihaz bedeli sorunları için Abonelik İptal ile itiraz metnini hazırlayın.",
    ctaLabel: "Dekoder iadesi başvurumu hazırla",
    prefill: { issue: "fatura" },
    metaTitle: "Dekoder İadesi Sorunu ve İtiraz Dilekçesi | Abonelik İptal",
    metaDescription: "Dekoder iadesi sürecinde yaşanan cihaz bedeli, tutanak veya iade reddi sorunları için hazır başvuru metni oluşturun.",
    faq: [
      { q: "Dekoderi iade ettim ama cihaz bedeli hâlâ görünüyor.", a: "İade tutanağı ve kargo fişini toplayın; Abonelik İptal ile yazılı itiraz metnini hazırlayıp kuruma iletebilirsiniz." },
    ],
  },

  // --- 5. E-ticaret iade/itiraz (6) ---
  {
    slug: "trendyol-para-iadem-yatmadi",
    category: "ecommerce",
    title: "Trendyol para iadem yatmadı",
    lead: "Trendyol siparişinizde iade talebiniz onaylandığı halde para henüz hesabınıza yatmadıysa Abonelik İptal ile itiraz metninizi hazırlayın.",
    ctaLabel: "Trendyol para iadesi başvurumu hazırla",
    prefill: { issue: "iade", company: "Trendyol" },
    metaTitle: "Trendyol Para İadem Yatmadı Ne Yapmalıyım? | Abonelik İptal",
    metaDescription: "Trendyol para iadesi gecikmesi, iade reddi ve satıcı sorunları için hazır başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "Trendyol para iadesi kaç günde yatmalı?", a: "Mesafeli Sözleşmeler Yönetmeliği kapsamında en geç 14 gün içinde ödeme yönteminize iade beklenir." },
      { q: "İade yatmazsa ne yapmalıyım?", a: "Sipariş bilgisi, iade talep numarası ve kart ekstresini toplayın; Abonelik İptal ile itiraz metnini hazırlayıp Trendyol'a iletebilirsiniz." },
    ],
  },
  {
    slug: "trendyol-iadem-reddedildi",
    category: "ecommerce",
    title: "Trendyol iadem reddedildi",
    lead: "Trendyol siparişinizde iade talebiniz reddedildiyse ret gerekçesine yazılı itiraz için Abonelik İptal ile başvuru metninizi hazırlayın.",
    ctaLabel: "Trendyol iade itiraz başvurumu hazırla",
    prefill: { issue: "iade", company: "Trendyol" },
    metaTitle: "Trendyol İadem Reddedildi Ne Yapmalıyım? | Abonelik İptal",
    metaDescription: "Trendyol iade reddi durumunda ret gerekçesine yazılı itiraz metni ve Tüketici Hakem Heyeti başvurusu için dosyanızı hazırlayın.",
    faq: [
      { q: "Ret gerekçesini nasıl belgelendirebilirim?", a: "Ret bildirimini yazılı isteyin, sipariş ve ürün fotoğraflarınızı, kargo fişini bir araya getirin." },
    ],
  },
  {
    slug: "amazon-turkiye-iade-itiraz",
    category: "ecommerce",
    title: "Amazon Türkiye iade & itiraz",
    lead: "Amazon Türkiye siparişinizde iade, değişim veya para iadesi sorunları için Abonelik İptal ile hazır başvuru metnini hazırlayın.",
    ctaLabel: "Amazon Türkiye iade başvurumu hazırla",
    prefill: { issue: "iade", company: "Amazon Türkiye" },
    metaTitle: "Amazon Türkiye İade ve İtiraz Süreci | Abonelik İptal",
    metaDescription: "Amazon Türkiye siparişlerinde iade, para iadesi ve ayıplı ürün sorunları için hazır başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "Amazon Türkiye iade süresi nedir?", a: "Amazon'un politikası kapsamında iade süresi ürün kategorisine göre değişir; para iadesi genellikle 14 gün içinde yapılır." },
    ],
  },
  {
    slug: "n11-iade-itiraz",
    category: "ecommerce",
    title: "n11 iade & itiraz",
    lead: "n11 siparişinizde iade, değişim veya para iadesi sorunları için Abonelik İptal ile hazır başvuru metnini oluşturun.",
    ctaLabel: "n11 iade başvurumu hazırla",
    prefill: { issue: "iade", company: "n11" },
    metaTitle: "n11 İade ve Para İadesi İtirazı | Abonelik İptal",
    metaDescription: "n11 siparişlerinde iade, para iadesi gecikmesi ve satıcı sorunları için hazır başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "n11'de satıcı cevap vermiyorsa ne yapmalıyım?", a: "n11 platformuna resmi başvurunuzu açın; sonuç alınmazsa Abonelik İptal ile yazılı itiraz metni hazırlayabilirsiniz." },
    ],
  },
  {
    slug: "ciceksepeti-iade-itiraz",
    category: "ecommerce",
    title: "ÇiçekSepeti iade & itiraz",
    lead: "ÇiçekSepeti siparişinizde iade, değişim veya para iadesi sorunları için Abonelik İptal ile hazır başvuru metnini oluşturun.",
    ctaLabel: "ÇiçekSepeti iade başvurumu hazırla",
    prefill: { issue: "iade", company: "ÇiçekSepeti" },
    metaTitle: "ÇiçekSepeti İade ve İtiraz Süreci | Abonelik İptal",
    metaDescription: "ÇiçekSepeti siparişlerinde iade, değişim, para iadesi ve ürün sorunları için hazır başvuru metni ve takip planı oluşturun.",
    faq: [
      { q: "ÇiçekSepeti'nde bozuk/hasarlı ürün geldiyse ne yapmalıyım?", a: "Ürünün teslim alındığı andaki fotoğraflarını çekin, siparişi platform üzerinden bildirin ve gerekirse Abonelik İptal ile yazılı itirazınızı hazırlayın." },
    ],
  },
  {
    slug: "ayipli-urun-iade-dilekcesi",
    category: "ecommerce",
    title: "Ayıplı ürün iade dilekçesi",
    lead: "Ayıplı, arızalı veya vaadedilen özellikleri taşımayan ürünlerin iadesi/değişimi için Abonelik İptal ile hazır başvuru metnini hazırlayın.",
    ctaLabel: "Ayıplı ürün başvurumu hazırla",
    prefill: { issue: "iade" },
    metaTitle: "Ayıplı Ürün İade Dilekçesi Hazırlama | Abonelik İptal",
    metaDescription: "Ayıplı veya arızalı ürünlerin iade, değişim ve tazminat süreçleri için hazır başvuru metni ve gerekli belge listesi oluşturun.",
    faq: [
      { q: "Ayıplı ürün için ne kadar süre içinde başvurmalıyım?", a: "6502 sayılı Kanun kapsamında ayıptan doğan sorumluluk süreleri geçerlidir; ürün fotoğrafı ve fatura ile bir an önce başvurmanız önerilir." },
      { q: "Satıcı iadeyi reddederse ne yapmalıyım?", a: "Ürün fotoğrafı, fatura ve yazışmalarınızı toplayın; Abonelik İptal ile Tüketici Hakem Heyeti başvurusu için dosya hazırlayabilirsiniz." },
    ],
  },
];
